import React from "react";
import t from "../../utils/translate";
import RoundButton from "../RoundButton";

export default function NextButton({
  onNext,
  isDisabled,
  label,
  size = "fixed",
  ...others
}) {
  return (
    <RoundButton
      onClick={onNext}
      isDisabled={isDisabled}
      size={size}
      disabledText="Please make a selection"
      {...others}
    >
      {label ? label : t("NEXT")}
    </RoundButton>
  );
}
